export const CRYPTO_KEY = 'vvf3-0ummy-4pp'